<template>
  <div id="app">
    <div>
      <!--       <nav-header />-->
      <new-header-again />
      <global-message />
      <loading />
      <!-- <banner-container v-if="bannerShow" /> -->
      <router-view class="router-view" />
      <!-- <root-footer /> -->
      <!--      <new-footer />-->
      <new-footer-again />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { SET_USER_MESSAGE } from '@/store/mutation-types'
import VueCookie from 'vue-cookie'
import bannerContainer from './components/banner'
import rootFooter from './components/rootFooter'
import globalMessage from './components/globalmessage'
import loading from './components/loading'
import navHeader from './components/header/index'
import newHeader from './components/header/newHeader'
import newHeaderAgain from './components/header/newHeaderAgain.vue'
import newFooter from './components/footer/newFooter'
import NewFooterAgain from './components/footer/newFooterAgain.vue'

export default {
  name: 'app',
  mounted () {
    this.initToken()
    window.onresize = this.watchEcharts
  },
  data () {
    return {
      newHome: true
    }
  },
  components: {
    NewFooterAgain,
    navHeader,
    newHeaderAgain,
    newHeader,
    bannerContainer,
    rootFooter,
    newFooter,
    loading,
    globalMessage
  },
  computed: {
    ...mapState(['charts', 'showNewIndex']),
    bannerShow: function () {
      return this.$route.name === 'home'
    }
  },
  methods: {
    ...mapMutations([SET_USER_MESSAGE]),
    initToken () {
      // eslint-disable-next-line
      let user_id = VueCookie.get("user_id");
      let token = VueCookie.get('token')
      let username = VueCookie.get('username')
      this.SET_USER_MESSAGE({ user_id, token, username })
    },
    watchEcharts () {
      let id, chart
      for (id in this.charts) {
        chart = this.charts[id]
        if (chart) {
          chart.resize({ width: 'auto', height: 'auto' })
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import "styles/app";
@import "styles/font-awesome/scss/font-awesome";
@import "styles/constants";
@font-face {
  font-family: "syht";
  src: url(./assets/font/syht.ttf);
}
* {
  margin: 0;
  padding: 0;
}
#app {
  position: relative;
  height: 100%;
}
pre {
  overflow: auto;
  word-wrap: break-word;
  margin: 0;
  padding: 0.85em 1em;
  margin-bottom: 1.275em;
  background-color: #f4eee0 !important;
}
.my-tool-tip-item-span {
  display: inline-block;
  min-width: 160px;
  font-weight: normal;
  font-style: normal;
}
.router-view {
  margin: 100px auto 74px;
  height: 100%;
}
ul {
  margin: 0;
  padding: 0;
}
.container-other .consume .date-picker-consume {
  font-family: "MicrosoftYaHei";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #666666;
}
.el-tabs__header{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue